import { CommonModule } from "@angular/common";
import { Component, ContentChild, inject, signal } from "@angular/core";
import { ConfirmSignUpComponent } from "./components/confirm-sign-up/confirm-sign-up.component";
import { ForgotPasswordComponent } from "./components/forgot-password/forgot-password.component";
import { SignInComponent } from "./components/sign-in/sign-in.component";
import { SignUpComponent } from "./components/sign-up/sign-up.component";
import { AuthenticateStateEnum } from "./enums/authenticate.enum";
import { AuthContentDirective } from "./directives/auth-content.directive";
import { AuthService } from "./services/auth.service";
import { ResetPasswordComponent } from "./components/reset-password/reset-password.component";
import { RiveComponent } from "../shared/components/rive/rive.component";

@Component({
  selector: "app-auth",
  standalone: true,
  imports: [
    CommonModule,
    SignInComponent,
    SignUpComponent,
    ConfirmSignUpComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    RiveComponent,
  ],
  templateUrl: "./auth.component.html",
})
export class AuthComponent {
  private readonly _authService: AuthService = inject(AuthService);

  protected readonly authenticateState = AuthenticateStateEnum;
  protected readonly isAuthenticated$ = this._authService.isAuthenticated();
  protected readonly state = signal(AuthenticateStateEnum.SIGN_IN);

  @ContentChild(AuthContentDirective)
  protected authContent?: AuthContentDirective;

  protected changeAuthState(event: AuthenticateStateEnum): void {
    this.state.set(event);
  }
}
